// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';
import $ from 'jquery';

export default class EshopGalleryPopup extends WebComponent {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }
    didMount() {
        this.on('click', this.handleClick);
    }
    handleClick(e) {
        const {
            item,
        } = this.props;
        let puUrl = '@gallery?ramJetLayoutContext=galleryPopup';
        const replaceImageSourceThumb = this.element.getAttribute('data-replace-image-source-thumb');
        const replaceImageSourceFullX1 = this.element.getAttribute('data-replace-image-source-full-x1');
        const replaceImageSourceFullX2 = this.element.getAttribute('data-replace-image-source-full-x2');

        puUrl += `&activeItem=${item}`;

        if (replaceImageSourceThumb) {
            puUrl += `&replaceImageSourceThumb=${replaceImageSourceThumb}`;
        }

        if (replaceImageSourceFullX1) {
            puUrl += `&replaceImageSourceFullX1=${replaceImageSourceFullX1}`;
        }

        if (replaceImageSourceFullX2) {
            puUrl += `&replaceImageSourceFullX2=${replaceImageSourceFullX2}`;
        }

        e.preventDefault();
        CursorSpinner.pushToQueue('showEshopGalleryPopup');

        let targetUrl = window.location.href;
        if (targetUrl.indexOf('#') != -1) {
            const splitUrl = targetUrl.split('#');
            targetUrl = splitUrl[0];
        }

        if (targetUrl.indexOf('?') === -1) {
            targetUrl += puUrl;
        } else {
            targetUrl = targetUrl.replace('?', `${puUrl}&`);
        }

        $.get(targetUrl, (data) => {
            CursorSpinner.removeFromQueue('showEshopGalleryPopup');
            edeeshopPopup.createPopup(data, 'esp__target--gallery esp-eshop-gallery');
        });
    };
}


// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/EshopGalleryPopup.js